import { ElementState } from "@creatomate/preview";
import { ElementSource, Subtitle } from "chq";

const loadJsonSubtitles = (
  subtitles: Subtitle[],
  subtitle: Subtitle,
  active: boolean,
  subtitlesElements: ElementState[],
  handleUpdateData: (data: ElementSource) => void
): Subtitle => {
  const extractIndex = (text: string): number => {
    const match = text.match(/sub-(\d+)-/);
    return match ? parseInt(match[1], 10) : 0;
  };

  const updatedSections = subtitlesElements.map(subtitleElement => {
    const endTime = subtitleElement.globalTime + subtitleElement.duration;
    return {
      text: subtitleElement.source.text,
      startTime: subtitleElement.globalTime,
      endTime,
      index: extractIndex(subtitleElement.source.name),
      originalStartTime: subtitleElement.globalTime,
      originalText: subtitleElement.source.text,
      originalEndTime: endTime,
      creatomateId: subtitleElement.source.id,
      track: subtitleElement.source.track
    };
  });

  handleUpdateData({
    subtitles: subtitles.map(existingSub => {
      if (existingSub.id !== subtitle.id) return existingSub;
      return { ...subtitle, active, sections: updatedSections, deleted: undefined };
    })
  });
  return { ...subtitle, active, sections: updatedSections };
};

export default loadJsonSubtitles;
